var exports = {
  "a": "triggerContent__V04-BC",
  "B": "triggerLabel__F6_qO9",
};

module.exports = exports;
